import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiActivity, FiAlertTriangle, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { WaterQualityCard } from "../../components/Cards";
import { SectionHeader, DashboardHeader } from "../../components/Shared";
import "../Dashboard.css";
import { waterQualityParams } from "../../Data/Data";

const TreatedWaterDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const normalCount = waterQualityParams.filter(p => p.status === 'normal').length;
  const warningCount = waterQualityParams.filter(p => p.status === 'warning').length;
  const criticalCount = waterQualityParams.filter(p => p.status === 'critical').length;

  return (
    <div className="env-dashboard">
      {/* Header with Solution Dropdown */}
      <DashboardHeader currentSolutionType="treated_water" />

      {/* Device Statistics */}
      <div className="env-dashboard-section">
        <SectionHeader title="Treated Water Monitoring Status" viewAllPath="/devices" />
        <div className="stats-grid">
          <div className="dashboard-stat-card stat-total" onClick={() => navigate('/devices')}>
            <div className="stat-icon">
              <FiActivity size={18} />
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{waterQualityParams.length}</h3>
              <p className="stat-label">Parameters</p>
            </div>
          </div>

          <div className="dashboard-stat-card stat-active" onClick={() => navigate('/devices')}>
            <div className="stat-icon">
              <FiCheckCircle size={18} />
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{normalCount}</h3>
              <p className="stat-label">Normal</p>
            </div>
          </div>

          <div className="dashboard-stat-card stat-warning" onClick={() => navigate('/devices')}>
            <div className="stat-icon">
              <FiAlertTriangle size={18} />
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{warningCount}</h3>
              <p className="stat-label">Warning</p>
            </div>
          </div>

          <div className="dashboard-stat-card stat-down" onClick={() => navigate('/devices')}>
            <div className="stat-icon">
              <FiXCircle size={18} />
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{criticalCount}</h3>
              <p className="stat-label">Critical</p>
            </div>
          </div>
        </div>
      </div>

      {/* Water Quality Parameters */}
      <div className="env-dashboard-section">
        <SectionHeader title="Water Quality Parameters" />
        <div className="env-dashboard-grid">
          {waterQualityParams.map((param, index) => (
            <div
              key={index}
              onClick={() => navigate('/treated-water/tw-001')}
              style={{ cursor: 'pointer' }}
            >
              <WaterQualityCard
                param={{ name: param.name, icon: param.icon }}
                value={param.value}
                unit={param.unit}
                status={param.status}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Loading Overlay */}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Loading dashboard data...</p>
        </div>
      )}
    </div>
  );
};

export default TreatedWaterDashboard;
